import { Component, Inject, OnInit, ViewChild, Output, EventEmitter, ɵConsole, AfterViewInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Formulario, FormularioPrefs } from '../formulario';

@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-form-dialog',
	templateUrl: './form-dialog.component.html'
})
export class FormDialog implements OnInit, AfterViewInit {

	@Output() fnchipChanges = new EventEmitter();
	@Output() fnestablecido = new EventEmitter();
	@Output() fncambiaFecha = new EventEmitter();
	@Output() fncambiaMes = new EventEmitter();
	@Output() fncambiaSelect = new EventEmitter();
	@Output() fncambiaInputtext = new EventEmitter();
	@Output() fnformReset = new EventEmitter();

	@ViewChild('formulario', { static: true }) formulario: Formulario;

	constructor(
		public dialogRef: MatDialogRef<FormDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any
		) {}

		prefs: FormularioPrefs;
		formtitle: string;
		formhint: string;
		registro?: any;

		ngOnInit() {
			this.prefs = this.data.prefs;
			this.formtitle = this.data.formtitle;
			this.formhint = this.data.formhint;
			this.registro = this.data.registro;
		}

		ngAfterViewInit(): void {
			this.init();
			return;
		}
		init() {
			this.formulario.init(this.prefs).then(() => {
				if (this.registro) {
					// va a editar, cargamos los datos en el formulario
					this.formulario.cargaDatos(this.registro);
				}
			});
		}
		cambiaAutocomplete(e: any) {
			this.fnestablecido.emit(e);
		}
		cambiaChips(e: any) {
			this.fnchipChanges.emit(e);
		}
		cambiaFecha(e: any) {
			this.fncambiaFecha.emit(e);
		}
		cambiaMes(e: any) {
			this.fncambiaMes.emit(e);
		}
		cambiaSelect(e: any) {
			this.fncambiaSelect.emit(e);
		}
		cambiaInputtext(e: any) {
			this.fncambiaInputtext.emit(e);
		}
		formReset(e: any) {
			this.fnformReset.emit(e);
		}
		close(status: Boolean): void {
			this.dialogRef.close(status);
		}
		cerrarSinSubmit(): void {
			if (this.formulario) {
				this.close(this.formulario.getForm().getRawValue());
			}
		}
		aceptar(): void {
			if (this.formulario) {
				this.formulario.onSubmit().then((result: Boolean) => {
					if (result) {
						this.close(result);
					}
				});
			}
		}
	}
